import { AlertTriangle, CloudOff, LoaderCircle, SearchX, ShieldAlert } from "lucide-react";
import type { ReactNode } from "react";

export type StatePanelState = "loading" | "empty" | "error" | "offline" | "permission-denied";

interface StatePanelProps {
  action?: ReactNode;
  className?: string;
  description: string;
  headingLevel?: 1 | 2 | 3;
  state: StatePanelState;
  title: string;
}

const stateIcons = {
  loading: LoaderCircle,
  empty: SearchX,
  error: AlertTriangle,
  offline: CloudOff,
  "permission-denied": ShieldAlert,
} as const;

export function StatePanel({
  action,
  className = "",
  description,
  headingLevel = 2,
  state,
  title,
}: StatePanelProps) {
  const Icon = stateIcons[state];
  const Heading = `h${String(headingLevel)}` as "h1" | "h2" | "h3";
  return (
    <section
      aria-busy={state === "loading" || undefined}
      className={["state-panel", `state-panel--${state}`, className].filter(Boolean).join(" ")}
      role={state === "error" ? "alert" : "status"}
    >
      <Icon
        aria-hidden="true"
        className={state === "loading" ? "state-panel__spinner" : undefined}
        size={24}
        strokeWidth={1.7}
      />
      <div>
        <Heading>{title}</Heading>
        <p>{description}</p>
      </div>
      {action}
    </section>
  );
}
